import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import './style.css';

/**
 * @name Volume
 * @function
 * @description Displays Volume
 * @returns {JSX}
 * @param {*} props 
 */
function Volume( props ){

    /**
     * @name select
     * @function
     * @param {Object} e Browser event object
     * @description Sets the current publication as the active publication to display in the `<Details />` component
     */
    const select = e => {
        e.preventDefault();
        props.callback({
            publication: {
                volume:  props.volume.volume,
                number:  props.volume.number,
                imageUrl: props.volume.imageUrl,
                pdfUrl: props.volume.pdfUrl,
                articles: props.volume.articles
            }
        });
    }
    
    return (
            <div className="grid item">
                <div className="link" onClick={ select }>
                    <LazyLoad height={250}>
                        <img 
                            src={ props.volume.imageUrl } 
                            alt={ props.imgkey } 
                            key={ props.imgkey }
                            className="cover"/>
                    </LazyLoad>
                    <span className="volume details">
                        <span className="volume name">{ props.name }</span>{ props.number }
                    </span>
                </div>
            </div>
    );
}


Volume.propTypes = {
    volume: PropTypes.shape({
            volume: PropTypes.number,
            imageUrl: PropTypes.string,
            pdfUrl: PropTypes.string,
            publishDate: PropTypes.instanceOf(Date),
            number: PropTypes.number,
            articles: PropTypes.array
        }).isRequired,
    name: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    imgkey: PropTypes.string.isRequired,
    callback:  PropTypes.func.isRequired
}

export default Volume;
